"use client";

import { Sparkles } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";
import type { ProductForClient } from "@/lib/shared/types/interfaces";
import { Button, cn } from "@/ui";
import { VirtualTryOnDialog } from "./VirtualTryOnDialog";

interface VirtualTryOnTriggerProps {
  product: ProductForClient;
  className?: string;
  initialVariantId?: string;
  fullWidth?: boolean;
}

export function VirtualTryOnTrigger(props: VirtualTryOnTriggerProps) {
  const { product, className, initialVariantId, fullWidth = false } = props;
  const t = useTranslations("virtual_try_on");
  const [open, setOpen] = useState(false);
  const hasImages = (product.images?.length ?? 0) > 0;

  if (!hasImages) {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        variant="outline"
        className={cn(
          fullWidth && "w-full",
          "group rounded-none border-border/70 bg-background/60 py-4 text-[11px] font-medium uppercase tracking-[0.15em] text-foreground transition-colors hover:border-primary/50 hover:bg-muted/30",
          className,
        )}
        onClick={() => setOpen(true)}
        data-testid="virtual-try-on-trigger"
      >
        <Sparkles className="mr-2 size-4 text-primary/80 transition-colors group-hover:text-primary" />
        {t("try_on_cta")}
      </Button>
      <VirtualTryOnDialog
        product={product}
        open={open}
        onOpenChange={setOpen}
        initialVariantId={initialVariantId}
      />
    </>
  );
}
